import { render, staticRenderFns } from "./Organ.vue?vue&type=template&id=1491e8d0&scoped=true"
import script from "./Organ.vue?vue&type=script&lang=js"
export * from "./Organ.vue?vue&type=script&lang=js"
import style0 from "./Organ.vue?vue&type=style&index=0&id=1491e8d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1491e8d0",
  null
  
)

export default component.exports